const COLLAPSED_PANE_RAIL_SCOPE = 'collapsed-pane-rail';

export const CollapsedPaneRailTestIds = {
  getExpandButtonId: side => `${COLLAPSED_PANE_RAIL_SCOPE}.${side}-expand-button`,
  getPrimaryIconButtonId: side => `${COLLAPSED_PANE_RAIL_SCOPE}.${side}-primary-button`,
  getTabButtonId: tabKey => `${COLLAPSED_PANE_RAIL_SCOPE}.tab-${tabKey}-button`,
};
